import * as angular from 'angular';
import { ClassOfDropdownModule } from '../../../../shared/components/class-of-dropdown/class-of-dropdown.module';
import { CreditGapsWizardSubjectTableModule } from '../../components/credit-gaps-wizard-subject-table/credit-gaps-wizard-subject-table.module';
import { WizardFilterActionsComponent } from '../../components/wizard-filter-actions/wizard-filter-actions.component';
import { CreditGapsClassOfTableModule } from './credit-gaps-class-of-table/credit-gaps-class-of-table.module';
import { CreditGapsWizardGradPlanTableModule } from './credit-gaps-wizard-grad-plan-table/credit-gaps-wizard-grad-plan-table.module';
import { CreditGapsWizardStepperModule } from './credit-gaps-wizard-stepper/credit-gaps-wizard-stepper.module';
import { CreditGapsWizardComponent } from './credit-gaps-wizard.component';

export const CreditGapsWizardModule = angular

  .module('creditGapsWizardModule', [
    CreditGapsWizardStepperModule,
    CreditGapsWizardGradPlanTableModule,
    CreditGapsClassOfTableModule,
    CreditGapsWizardSubjectTableModule,
    ClassOfDropdownModule,
  ])
  .component('creditGapsWizard', CreditGapsWizardComponent)
  .component('wizardFilterActions', WizardFilterActionsComponent).name;
